/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import type { Listable, Pin, Property } from '@zcode/state-type'
import * as SourceC from '../../../../shared/constants/source'

export const isShortTermViewV1 = (t: Listable | Property | Pin) =>
  (SourceC.bookingProviders as ReadonlyArray<(typeof t)['feedName']>).includes(t.feedName)
